<form [formGroup]="settingsForm" (ngSubmit)="onSubmit()">
    <h2 class="section-title">{{ 'components.settingsForm.userSection.title' | translate }}</h2>
    <div class="card form-grid form-grid--2" formGroupName="userGroup">
        <div class="form-field">
            <label for="lastnameInput" class="form-field__label form-field__label--required">
                {{ 'components.settingsForm.userSection.lastname.label' | translate }}
            </label>
            <input
                id="lastnameInput"
                pInputText
                type="text"
                formControlName="lastname"
                [placeholder]="'components.settingsForm.userSection.lastname.placeholder' | translate" />
            @if (userFormGroup.get('lastname')?.errors?.required && userFormGroup.get('lastname')?.touched) {
                <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
            }
        </div>
        <div class="form-field">
            <label for="firstnameInput" class="form-field__label form-field__label--required">
                {{ 'components.settingsForm.userSection.firstname.label' | translate }}
            </label>
            <input
                id="firstnameInput"
                pInputText
                type="text"
                formControlName="firstname"
                [placeholder]="'components.settingsForm.userSection.firstname.placeholder' | translate" />
            @if (userFormGroup.get('firstname')?.errors?.required && userFormGroup.get('firstname')?.touched) {
                <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
            }
        </div>
        <div class="form-field">
            <label for="roleInput" class="form-field__label">
                {{ 'components.settingsForm.userSection.role.label' | translate }}
            </label>
            <input
                id="roleInput"
                pInputText
                type="text"
                formControlName="role"
                [placeholder]="'components.settingsForm.userSection.role.placeholder' | translate" />
        </div>
        <div class="form-field">
            <label for="emailInput" class="form-field__label form-field__label--required">
                {{ 'components.settingsForm.userSection.email.label' | translate }}
            </label>
            <input
                id="emailInput"
                pInputText
                type="text"
                formControlName="email"
                [placeholder]="'components.settingsForm.userSection.email.placeholder' | translate" />
            @if (userFormGroup.get('email')?.errors?.required && userFormGroup.get('email')?.touched) {
                <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
            }
        </div>
        <div class="form-field">
            <label for="phoneNumberInput" class="form-field__label form-field__label--required">
                {{ 'components.settingsForm.userSection.phoneNumber.label' | translate }}
            </label>
            <input
                id="phoneNumberInput"
                pInputText
                type="text"
                formControlName="phoneNumber"
                [placeholder]="'components.settingsForm.userSection.phoneNumber.placeholder' | translate" />
            @if (userFormGroup.get('phoneNumber')?.errors?.required && userFormGroup.get('phoneNumber')?.touched) {
                <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
            }
            @if (userFormGroup.get('phoneNumber')?.errors?.invalidPn && userFormGroup.get('phoneNumber')?.touched) {
                <small class="p-error">{{
                    'components.settingsForm.userSection.phoneNumber.validation.invalid' | translate
                }}</small>
            }
        </div>
    </div>
    <h2 class="section-title">{{ 'components.settingsForm.securitySection.title' | translate }}</h2>
    <div class="card form-grid form-grid--2" formGroupName="securityGroup">
        <div class="form-field">
            <label for="oldPasswordInput" class="form-field__label form-field__label--required">
                {{ 'components.settingsForm.securitySection.oldPassword.label' | translate }}
            </label>
            <p-iconfield>
                <p-inputicon styleClass="ms ms-key" />
                <input
                    id="oldPasswordInput"
                    type="password"
                    formControlName="oldPassword"
                    autocomplete="off"
                    pInputText
                    [placeholder]="'components.settingsForm.securitySection.oldPassword.placeholder' | translate" />
            </p-iconfield>
            @if (
                securityFormGroup.get('oldPassword')?.errors?.required && securityFormGroup.get('oldPassword')?.touched
            ) {
                <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
            }
        </div>
        <!-- Keeps the new password and its confirmation on the next row. -->
        <div class="hidden md:block" aria-hidden="true"></div>
        <div class="form-field">
            <label for="newPasswordInput" class="form-field__label form-field__label--required">
                {{ 'components.settingsForm.securitySection.newPassword.label' | translate }}
            </label>
            <p-iconfield>
                <p-inputicon styleClass="ms ms-key" />
                <input
                    id="newPasswordInput"
                    type="password"
                    formControlName="newPassword"
                    autocomplete="new-password"
                    pInputText
                    [placeholder]="'components.settingsForm.securitySection.newPassword.placeholder' | translate" />
            </p-iconfield>
            @if (
                securityFormGroup.get('newPassword')?.errors?.required && securityFormGroup.get('newPassword')?.touched
            ) {
                <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
            }
            @if (securityFormGroup.errors?.mustNotMatch && securityFormGroup.get('newPassword')?.touched) {
                <small class="p-error">{{
                    'components.settingsForm.securitySection.newPassword.mustNotMatch' | translate
                }}</small>
            }
            @if (
                securityFormGroup.get('newPassword')?.errors?.invalidPassword &&
                securityFormGroup.get('newPassword')?.touched
            ) {
                <small
                    class="p-error"
                    [innerHtml]="
                        'components.settingsForm.securitySection.newPassword.invalidPassword' | translate
                    "></small>
            }
        </div>
        <div class="form-field">
            <label for="confirmPasswordInput" class="form-field__label form-field__label--required">
                {{ 'components.settingsForm.securitySection.confirmPassword.label' | translate }}
            </label>
            <p-iconfield>
                <p-inputicon styleClass="ms ms-key" />
                <input
                    id="confirmPasswordInput"
                    type="password"
                    formControlName="confirmPassword"
                    autocomplete="new-password"
                    pInputText
                    [placeholder]="'components.settingsForm.securitySection.confirmPassword.placeholder' | translate" />
            </p-iconfield>
            @if (
                securityFormGroup.get('confirmPassword')?.errors?.required &&
                securityFormGroup.get('confirmPassword')?.touched
            ) {
                <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
            }
            @if (securityFormGroup.errors?.mustMatch && securityFormGroup.get('confirmPassword')?.touched) {
                <small class="p-error">{{
                    'components.settingsForm.securitySection.confirmPassword.mustMatch' | translate
                }}</small>
            }
        </div>
    </div>
    <div class="form-actions">
        <!-- Disabled only while there is nothing to save: an invalid section shows its errors on submit. -->
        <p-button
            type="submit"
            [label]="'components.settingsForm.button.settings' | translate"
            [loading]="loading"
            [disabled]="!hasChanges()" />
    </div>
</form>
